export const UPDATE = 'meal/update';
export const UPDATE_MEAL_NAME = 'meal/updateMealName';
export const ADD_FOOD_ENTRIES = 'meal/addFoodEntries';
export const DELETE_FOOD_ENTRY = 'meal/deleteFoodEntry';
export const UPDATE_FOOD_ENTRY = 'meal/updateFoodEntry';
